'use client';

import styled from 'styled-components';
import { theme } from '@/config/theme';

export type BadgeVariant = 'success' | 'warning' | 'error' | 'info';

interface BadgeProps {
  variant?: BadgeVariant;
  children: React.ReactNode;
  title?: string;
  style?: React.CSSProperties;
}

const StyledBadge = styled.span<{ $variant: BadgeVariant }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  
  ${({ $variant }) => {
    switch ($variant) {
      case 'success':
        return `
          background: ${theme.colors.status.success}15;
          color: ${theme.colors.status.success};
          border: 1px solid ${theme.colors.status.success}30;
          border-radius: 4px;
        `;
      case 'warning':
        return `
          background: ${theme.colors.status.warning}15;
          color: ${theme.colors.status.warning};
          border: 1px solid ${theme.colors.status.warning}30;
          border-radius: 4px;
        `;
      case 'error':
        return `
          background: ${theme.colors.status.error}15;
          color: ${theme.colors.status.error};
          border: 1px solid ${theme.colors.status.error}30;
          border-radius: 4px;
        `;
      case 'info':
        return `
          background: ${theme.colors.status.info}15;
          color: ${theme.colors.status.info};
          border: 1px solid ${theme.colors.status.info}30;
          border-radius: 4px;
        `;
      default:
        return `
          background: ${theme.colors.gray[100]};
          color: ${theme.colors.gray[700]};
          border: 1px solid ${theme.colors.gray[300]};
          border-radius: 4px;
        `;
    }
  }}
`;

export const Badge: React.FC<BadgeProps> = ({ 
  variant = 'success', 
  children, 
  title,
  style 
}) => {
  return (
    <StyledBadge $variant={variant} title={title} style={style}>
      {children}
    </StyledBadge>
  );
};
